module.exports = __webpack_public_path__ + "static/media/page-builder-main.31fddaa8.png";